import { trigger, transition, style, animate, query, state } from '@angular/animations';

const animationTime = '0.35s';
const animationSelector = 'content-selector2';

export const ChildAnimation = trigger('childAnimation', [

  transition('false => true', [
    query(
      animationSelector,
      [
        // style({ opacity: 1 }),
        animate(animationTime + ' ease-out', style({ opacity: 0 })),
      ],
      { optional: true }
    ),
  ]),
 
  transition('true => false', [
    query(
      animationSelector,
      [
        // transition(':enter', [style({ opacity: 0 }), animate('1s ease-in', style({ opacity: 1 }))]),
        style({ opacity: 0 }),
        animate(animationTime + ' ease-in', style({ opacity: 1 })),
      ],
      { optional: true }
    ),
  ]),
]);
